import {serviceRiddles} from './service'

serviceRiddles.init()

export default serviceRiddles
